import React, { useMemo, useState } from 'react';
import { CloseButton } from 'react-bootstrap';
import AVATAR_IMAGE from '../assets/img/nick-user2.png';
import { selectLoader } from 'utils/Helpers';

const ShareClientPopover = ({
  members = [],
  selectedUsers = [],
  onSelect,
  onRemove,
  onClose,
  onShare,
  shareLoading
}) => {
  const [search, setSearch] = useState('');
  console.log(members, 'members in popover');
  
  const isSelected = (id) => selectedUsers.some((u) => u.value === id);

  const filteredMembers = useMemo(() => {
    return members.filter((m) => (m.label)?.toLowerCase().includes(search.toLowerCase()));
  }, [members, search]);

  return (
    <div className="share-popover">
      {/* HEADER */}
      <div className="share-header">
        <div>
          <h4>Share with client</h4>
          <p>Share your project collaborate with your client</p>
        </div>
        {/* <CloseButton onClick={onClose} /> */}
      </div>

      {/* SELECTED USERS */}
      {/* <div className="selected-users">
        {selectedUsers.map((user) => (
          <div className="selected-tag" key={user._id}>
            {user.fullName}
            <span onClick={() => onRemove(user._id)}>×</span>
          </div>
        ))}
      </div> */}

      {/* INPUT */}
      <input
        className="share-input"
        placeholder="Enter email or name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* LIST */}
      <div className="share-list">
        {filteredMembers.map((user) => (
          <div
            key={user.value}
            className={`share-item ${isSelected(user.value) ? 'selected' : ''}`}
            onClick={() => !isSelected(user.value) && onSelect(user)}>
            <div className="user-info">
              <img src={user.profilePic || AVATAR_IMAGE} alt="user" />
              <span>{user.label}</span>
            </div>

            {isSelected(user.value) && (
              <CloseButton
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(user.value);
                }}
              />
            )}
          </div>
        ))}
      </div>

      {/* BUTTON */}
      <button className="btn-black w-100 share-btn" onClick={onShare} disabled={shareLoading}>
        {shareLoading ? selectLoader(20) : 'Share'}
      </button>
    </div>
  );
};

export default ShareClientPopover;
